export default {
    si:'Si'
    ,no:'No'
    ,errore:'Errore'
    ,modifica:'Modifica'
    ,salvainvia:'Salva ed Invia'
    ,warning:'ATTENZIONE'
    ,aggiungi:'Aggiungi'
    ,salvamodifiche:'Salva le modifiche'
    ,cancella:'Cancella'
    ,esito:'Stato di consultazione'
    
    
    ,testo:'testo'
    ,titolo:'titolo'
    ,parolechiave:'Parole Chiave'
    ,parolechiaveHolder: "Indicare le parole chiavi del proprio abstract"
    ,cognome:'cognome'
    ,nome:'nome'
    ,email:'email'
    ,cellulare:'cellulare'
    ,affiliazione:'affiliazione'
    ,scegliere_lista:'Scegliere dalla lista'
    ,scegliere_topic:'Scegliere il topic tra quelli disponibili'
    ,codiceconsultazione:'Codice di consultazione'
    ,codicefiscale: 'Codice Fiscale'
    ,socio:'Socio'
    ,nazionelavoro:'Nazione Lavoro'
    ,regionelavoro:'Regione Lavoro'
    ,categoriaprofessionale:'Categoria Professionale'
    ,annonascita:'Anno di nascita'
    ,allegato:'Immagine da allegare'
  
  
    ,assistenzaSection:'ASSISTENZA'
    ,assistenzaHelp:`Per ricevere assistenza potete contattare la referente di Biomedia:`

    ,lineeguidaSection:'LINEE GUIDA'
    ,lineeguidaCheck:'Ho letto e <b>compreso</b>, quindi accetto le linee guida per l\'invio del Abstract'

    ,datipresentatoreSection:'CORRESPONDING AUTHOR'
    ,datipresentatoreHelp: ''

    ,affiliazioniSection:'AFFILIAZIONI'
    ,affiliazioniHelp:`Scrivere in minuscolo con iniziale maiuscola senza indicare la via (es. Lab. di Biochimica Clinica, Osp. Fatebenefratelli, Milano)
    <div class="row pad" style="margin-top:16px;"><div class="col sm yo-align-right">»</div><div class="col s11m">NON inserire più volte la stessa affiliazione</div></div>
    <div class="row pad"><div class="col sm yo-align-right">»</div><div class="col s11m">Utilizzare una sola riga per ogni affiliazione</div></div>
    <div class="row pad"><div class="col sm yo-align-right">»</div><div class="col s11m">Utilizzare sigle e abbreviazioni (es. Dip., Sez., Lab., U.O., Osp.)</div></div>`
    ,affiliazioniOrderHelp:`Per cambiare l'ordine delle affiliazioni basta trascinare e posizionare nella posizione corretta l'affiliazione da cambiare 
    <br />
    Per cambiare o cancellare una delle affiliazioni già inserite, cliccare sull'affiliazione che si desidera modificare, e procedere con le modifiche. `

    ,autoriSection:'AUTORI'
    ,autoriHelp:`Scrivere il nome per esteso con l'iniziale maiuscola (es. Rossi Pier Luigi no Rossi P.L.)
    <div class="row pad" style="margin-top:16px;"><div class="col sm yo-align-right">1</div><div class="col s11m">Inserite il cognome e il nome dell'autore</div></div>
    <div class="row pad"><div class="col sm yo-align-right">2</div><div class="col s11m">Dal menù a tendina selezionare l'affiliazione o le affiliazioni di riferiemento fra quelle precedentemente inserite</div></div>
    <div class="row pad"><div class="col sm yo-align-right">3</div><div class="col s11m">Confermare i dati con <i class="el-icon-plus"></i> oppure se si sta modificando un autore precedentemente inserito con <i class="el-icon-edit"></i> </div></div>`
    ,autoriOrderHelp:`Per cambiare l'ordine degli autori basta trascinare e posizionare nella posizione corretta l'autore da cambiare
    <br />
    Per cambiare o cancellare un autore già inserito, cliccare sull'autore che si desidera modificare, e procedere con le modifiche.`

    ,paSection:'PERSONA CHE PRESENTERA’ IL LAVORO AL CONVEGNO'
    ,paName:'Primo Autore'

    ,datiabsSection:'DATI ABSTRACT'
    ,datiabsOrale:`Vuoi presentare l’abstract come comunicazione orale?`
    ,datiabsPoster:`Vuoi presentare l’abstract come poster?`
    ,datiabsPosterNoOrale:`Qualora l’abstract non venisse accettato come comunicazione orale, lo vuole presentare come poster?`
    

    ,testoSection:'TITOLO E TESTO'
    ,titoloolder:'indicare il titolo per abstract'
    ,maxparoleWarning:`Superato il numero masssimo di parole che è di`

    ,datitestoHelp:`Se doveste avere problemi ad incollare il vostro testo dal programma MS word, vi consigliamo di passare dal blocco note prima di incollare nel gestionale.
    <br />Potete anche provare ad incollare il testo con la combinazine di caratteri CTRL+SHIFT+v`

    ,previewSection:'PREVIEW ED INVIO'
    ,previewHelp:`Cliccare il pulsante preview per visionare il proprio absract.
    <br />
    Una volta verificato accettare la presa visione per poter inviare abstract.
    <br />
    Fino a quando non invierete l'abstract questo non sarà valido.`
    ,previewCheck:'Ho preso visione della preview'
    ,previewCheckHelp:`Per inviare il proprio abstract bisogna prima spuntare il box di presa visione ed accettazione della preview.
    <br />
    Se invece si volessero apportare delle modifiche premere il pulsante "Modifica"`
    ,previewCheckedHelp:`Complimenti ora può inviare l'abstract!`


    ,eRequired:{
        premail:'L\'email della persona di contatto è obbligatoria'
        ,prcognome:'Il cognome della persona di contatto è obbligatorio'
        ,prnome:'Il nome della persona di contatto è obbligatorio'
        ,paemail:'L\'email del primo autore è obbligatoria'
        ,pacellulare:'Il cellulare del primo autore è obbligatorio'
        ,pacodicefiscale:'Il codicefiscale del primo autore è obbligatorio'
        ,panato:'L\'anno di nascita del primo autore è obbligatorio'
        ,pacategoriaprofessionale:'La categoria professionale del primo autore è obbligatorio'
        ,paregionelavoro:'La regione del primo autore è obbligatorio'
        ,panazionelavoro:'La nazione di lavoro del primo autore è obbligatorio'
        ,paassociazione:'Indicare se si il primo autore sia socio o meno è obbligatorio'
        ,poster:'La scelta se presentare abstract come Poster è obbligatoria'
        ,topicposter:'La scelta del topic Poster è obbligatoria'
        ,comunicazione:'La scelta se presentare abstract come comunicazione orale è obbligatoria'
        ,topiccomunicazione:'La scelta del topic Comunicazione Orale è obbligatoria'
        ,titolo:'Il titolo dell\'abstract è obbligatorio'
        ,parolechiave:'Le parole chiave sono obbligatorie'
        ,codiceconsultazione: 'Il codice di consultazione è obbligatorio'
    }

    ,eEmail:'Indirizzo email non corretto'

    ,inviatoText:'Complimenti il suo abstract è stato inviato correttamente.'
    ,inviatoButton:'Invia nuovo Abstract'

    ,privacyTitle: 'INFORMATIVA PRIVACY AI SENSI DELL\'ART. 13 REGOLAMENTO EUROPEO N. 679/2016'
    ,privacyText: 'Si prega di prendere visione dell\'Informativa sul Trattamento dei Dati <a href="https://www.biomedia.net/gdpr/privacy-ABSTRACT.pdf">cliccando qui</a>'

    
}



// WEBPACK FOOTER //
// ./src/it-136.js